import { fetchWithAuth } from "../utils/fetchWithAuth";

const createPayment = async (paymentData) => {
  const response = await fetchWithAuth("/webpay/create-transaction", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(paymentData),
  });
  return await response.json();
};


const commitPayment = async (token) => {
  try {
    const response = await fetchWithAuth(`/webpay/commit-transaction`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ token: token }),
    });

    if (!response.ok) {
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }
    return await response.json();
  } catch (error) {
    console.error("Error al confirmar el pago:", error);
    throw error;
  }
};

const getPaymentStatus = async (token) => {
  const response = await fetchWithAuth(`/webpay/transaction-status?token=${token}`, {
    method: "GET",
  });
  return response;
};

const paymentCancelled = async (buyOrder) =>{
  const response = await fetchWithAuth(`/webpay/cancel-payment/${buyOrder}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ buyOrder }),
  });
  return response;
}

// NUEVO: obtener resultado por buyOrder (para URL limpia)
const getPaymentResult = async (buyOrder) => {
  const res = await fetchWithAuth(`/webpay/payment-result/${buyOrder}`, {
    method: "GET",
  });
  if (!res.ok) throw new Error(`Error obteniendo resultado: ${res.status}`);
  return await res.json();
};


export { createPayment, commitPayment, getPaymentStatus, paymentCancelled, getPaymentResult };